import { BlockContent } from "components/BlockContent";
import React from "react";
import { OfferTokenValues } from "types/api/exclusive_offers.d";
import { SanityBlock } from "types/graphql-types";
import { offerPlaceholderResolver } from "./utils";

export interface OfferTokenizedContentProps {
  content: SanityBlock[] | string;
  tokenValues?: OfferTokenValues;
}

const OfferTokenizedContent: React.FC<OfferTokenizedContentProps> = ({
  content,
  tokenValues = {}
}) => {
  return (
    <BlockContent
      blocks={content}
      placeholderResolver={offerPlaceholderResolver(tokenValues)}
    />
  );
};

export default React.memo(OfferTokenizedContent);
